export enum TableLayoutMode {
	Table = 'table',
	Cards = 'cards',
}

export enum TableHighlightMode {
	'None' = 'none',
	'AlternateRows' = 'alternateRows',
}

export enum TableHighlightColor {
	'White' = 'white',
	'Black' = 'black',
}

/**
 * Criteria to decide when to use 'Table View' vs 'Card View'
 */
export enum UseTableViewCriteria {
	Never = 'never',
	Always = 'always',
	FromBreakpointSm = 'fromBreakpointSm',
	FromBreakpointMd = 'fromBreakpointMd',
	FromBreakpointLg = 'fromBreakpointLg',
	FromBreakpointXl = 'fromBreakpointXl',
	HeadingsFitOnOneLine = 'headingsFitOnOneLine',
	HeadingsFitOnTwoLines = 'headingsFitOnTwoLines',
	HeadingsFitOnThreeLines = 'headingsFitOnThreeLines',
	AllCellsFitOnOneLine = 'allCellsFitOnOneLine',
	AllCellsFitOnTwoLines = 'allCellsFitOnTwoLines',
	AllCellsFitOnThreeLines = 'allCellsFitOnThreeLines',
}

export enum GroupByOption {
	RowHeader = 'rowHeader',
	ColumnHeader = 'columnHeader',
	None = 'none',
}

/**
 * When calculating where a dynamic breakpoint should be, we can only do this by looking at the changed window width and
 * seeing if text inside cells would fit into x number of lines. We can't calculate the exact spot where this occurs in
 * advance.
 *
 * Therefore, instead of having a single cached breakpoint value, we have to keep track of a range, with the exact value
 * being an unknown inside that range, and the range should get smaller and more accurate with each new calculation.
 */
export interface TableLayoutBreakpointRangeCache {
	knownRangeMinimum: number;
	knownRangeMaximum: number;
}
